import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, throwError, startWith, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { TokenService } from './services/token.service';
import { AuthService } from './services/auth.service';
import { LoggerService } from './services/logger.service';
import { environment } from '../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private tokenService: TokenService,
    private authService: AuthService,
    private logger: LoggerService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {

    return this.tokenService.getTokenUserCredentials().pipe(
      switchMap((token) => {
        
        if (token && !request.url.includes('/api/Login/')) {

          return this.tokenService.decodeToken(token).pipe(
            switchMap((payload) => {
              const isExpiringSoon = payload?.expiresAt
                ? payload.expiresAt.toDate().getTime() - Date.now() <= 20 * 60 * 1000
                : false;

              if (isExpiringSoon) {
                this.logger.log('AuthInterceptor: Token inválido ou expirado. Tentando renovar.');
                return this.authService.refreshToken().pipe(
                  switchMap((result) => {
                    return this.tokenService.getTokenUserCredentials().pipe(
                      switchMap((newToken) => {
                        if (newToken) {
                          return this.tokenService.decodeToken(newToken).pipe(
                            switchMap((decodedNew) => {
                              return next.handle(request);
                            })
                          );
                        }
                        return next.handle(request);
                      })
                    );
                  }),
                  catchError((error) => {
                    this.logger.log('AuthInterceptor: Erro 401 ao renovar token. Redirecionando.');
                    this.redirectToLogin();
                    return throwError(() => error);
                  })
                );
              }

              return next.handle(request);
            })
          );
        }
        return next.handle(request);
      }),
      catchError((error) => {
        if (error.status === 401) {
          console.log(error)
          this.logger.log('Acesso negado!.', error);
          this.redirectToLogin();
          return throwError(() => error);
        }

        this.logger.log('Erro desconhecido retornado pelo backend ao interceptar.', error);
        return throwError(() => error);
      })
    );
  }

  private redirectToLogin(): void {
    location.href = `${environment.authUrl}/?url=${encodeURIComponent(location.host)}${encodeURIComponent(location.pathname)}`;
  }
}
